import useProfile from "../../../../hooks/use-profile.ts";
import styles from "./index.module.scss";

const UserProfile = () => {
  const profile = useProfile();

  return (
    <div className={styles.userProfile}>
      <img className={styles.avatar} src={profile?.avatar} alt="" />
      <div className={styles.content}>
        <div className={styles.username}>充值账号：{profile?.nickname}</div>
        <div className={styles.tag} />
      </div>
    </div>
  );
};

export default UserProfile;
